// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3rHLS","description":"PatientConsentPreview_description__3a4U3"};